module.exports = __webpack_public_path__ + "img/572ff3d.jpg";